import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getList: {
        url: `${customerApi}/api/user_welcome_messages`,
        type: 'GET',
    },

    editUser: {
        url: `${customerApi}/api/user_welcome_messages/{id}`,
        type: 'PUT',
    },

    addUser: {
        url: `${customerApi}/api/user_welcome_messages`,
        type: 'POST',
    },
    deleteUser: {
        url: `${customerApi}/api/user_welcome_messages/{id}`,
        type: 'DELETE',
    },
    downloadTemplate: {
        url: `${customerApi}/api/oem_miniso/user_group_chat_link.xlsx`,
        type: 'GET',
    },
    importGroupLink: {
        url: `${customerApi}/api/oem_miniso/user_group_chat_link/import`,
        type: 'POST',
    },
}
